import { Button } from '@/components/button';
import { Icon } from '@/components/icon';
import { company } from '@/data/company';

interface CTABannerProps {
  title?: string;
  description?: string;
}

export function CTABanner({
  title = 'Jetzt unverbindlich anfragen',
  description = 'Kostenlose Erstbegutachtung – schriftliches Festpreis-Angebot innerhalb weniger Tage.',
}: CTABannerProps): React.ReactNode {
  return (
    <div className="rounded-lg bg-bark px-6 py-10 text-paper sm:px-12 sm:py-14">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="mb-3 font-display text-3xl font-semibold tracking-tight text-paper sm:text-4xl">
          {title}
        </h2>
        <p className="mb-8 text-lg text-paper/80">{description}</p>
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button as="link" to="/kontakt" variant="inverse" size="lg">
            <Icon name="Mail" className="h-5 w-5" />
            Anfrage stellen
          </Button>
          <Button
            as="anchor"
            href={company.phone.href}
            variant="ghost"
            size="lg"
            className="border border-paper/30 bg-transparent text-paper hover:bg-paper/10"
          >
            <Icon name="Phone" className="h-5 w-5" />
            {company.phone.display}
          </Button>
        </div>
      </div>
    </div>
  );
}
